import {createSlice, type PayloadAction} from "@reduxjs/toolkit";

interface DialogState {
  isOpen: boolean;
  type: 'alert' | 'confirm' | null;
  title: string;
  message: string;
}

const initialState: DialogState = {
  isOpen: false,
  type: null,
  title: '',
  message: '',
};

const dialogSlice = createSlice({
  name: 'dialog',
  initialState,
  reducers: {
    // 다이얼로그를 여는 액션 (type, title, message를 받음)
    openDialog: (state: any, action: PayloadAction<Omit<DialogState, 'isOpen'>>) => {
      state.isOpen = true;
      state.type = action.payload.type;
      state.title = action.payload.title;
      state.message = action.payload.message;
    },
    // 다이얼로그를 닫는 액션
    closeDialog: (state: any) => {
      state.isOpen = false;
    },
  },
});

export const { openDialog, closeDialog } = dialogSlice.actions;
export default dialogSlice.reducer;